﻿export interface IGroup {
    id: number,
    name: string,
    description: string,
    isSuper: boolean,
    useCP: boolean,
    manageUsers: boolean,
    changeUsername: boolean,
    changePassword: boolean,
    editProfile: boolean,
    isCenter: boolean,
    addCenterUser: boolean,
    isLogisticsProvider: boolean,
    isXmKitVendor: boolean,
    isSerologyVendor: boolean,
    isRecipient: boolean,
    isDonor: boolean,
    isPhlebot: boolean,
    isNkrLab: boolean,
    accessTicketing: boolean,
    accessTicketGroup: number,
    accessTicketGroupName: string,
    isNkdo: boolean,
    isIlda: boolean,
    isOpo: boolean
}
